export { Person as default } from './Person';
